import NavBar from '../NavBar';
import Footer from '../footer/Footer'
import { Outlet } from 'react-router-dom';
import './RootLayout.css';

const RootLayout = () => {
  return (
    <div className="layout-wrapper">
      <NavBar />
      <div className="main-content">
        <Outlet />
      </div>
      <Footer />
    </div>
  );
};


export default RootLayout;
